import React, { Component } from 'react';

class KioskContentContainer extends Component {
    render() {
        return(
            <div className="kiosk__column kiosk__column--card">
                {this.props.children}
            </div>
        )
    }
}

export default KioskContentContainer
